function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import { Alert, Tag, Tabs, Divider, Descriptions } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import { Page, Document, pdfjs } from 'react-pdf';
import Moment from "react-moment";
import Common from "./includes/Common";
import { Folder2Open, Alexa, ShareFill } from "react-bootstrap-icons";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
pdfjs.GlobalWorkerOptions.workerSrc = "//cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(pdfjs.version, "/pdf.worker.js");
var MailView = function MailView(_ref) {
  var m = _ref.m;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    numberOfPages = _useState2[0],
    setNumberOfPages = _useState2[1];
  var _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    pageN = _useState4[0],
    setPageN = _useState4[1];
  var onDocumentLoadSuccess = function onDocumentLoadSuccess(_ref2) {
    var numberOfPages = _ref2.numberOfPages;
    setNumberOfPages(numberOfPages);
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: m != null && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("div", {
        className: "eduBkg",
        children: /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsx(Row, {
            children: /*#__PURE__*/_jsx(Col, {
              children: /*#__PURE__*/_jsxs(Tabs, {
                animated: true,
                defaultActiveKey: 1,
                children: [/*#__PURE__*/_jsx(Tabs.TabPane, {
                  tab: /*#__PURE__*/_jsxs("b", {
                    children: [/*#__PURE__*/_jsx(Folder2Open, {
                      size: 30
                    }), "Courrier"]
                  }),
                  children: /*#__PURE__*/_jsxs("div", {
                    className: "tr-white",
                    children: [/*#__PURE__*/_jsxs(Descriptions, {
                      column: 2,
                      title: /*#__PURE__*/_jsx("b", {
                        children: m.sender
                      }),
                      children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                        label: "Date",
                        children: /*#__PURE__*/_jsx(Moment, {
                          format: "DD/MM/YYYY",
                          children: m.created_at
                        })
                      }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                        label: "Type",
                        children: [m.type == 0 && /*#__PURE__*/_jsx(Tag, {
                          color: "red",
                          children: "Entrant"
                        }), m.type == 1 && /*#__PURE__*/_jsx(Tag, {
                          color: "green",
                          children: "Sortant"
                        }), m.type == 2 && /*#__PURE__*/_jsx(Tag, {
                          color: "yellow",
                          children: "Entrant Portail"
                        })]
                      }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                        label: "Priorit\xE9",
                        children: [m.priority == 0 && /*#__PURE__*/_jsx(Tag, {
                          color: "lime",
                          children: /*#__PURE__*/_jsx("b", {
                            children: "Faible"
                          })
                        }), m.priority == 1 && /*#__PURE__*/_jsx(Tag, {
                          color: "#87d068",
                          children: /*#__PURE__*/_jsx("b", {
                            children: "Normal"
                          })
                        }), m.priority == 2 && /*#__PURE__*/_jsx(Tag, {
                          color: "#FF9C9A",
                          children: /*#__PURE__*/_jsx("b", {
                            children: "Elev\xE9e"
                          })
                        }), m.priority == 3 && /*#__PURE__*/_jsx(Tag, {
                          color: "#F50",
                          children: /*#__PURE__*/_jsx("b", {
                            children: "Urgent"
                          })
                        })]
                      })]
                    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), m.file != null && /*#__PURE__*/_jsx(DocViewer, {
                      documents: [{
                        uri: Common.baseUrl + m.file
                      }],
                      pluginRenderers: DocViewerRenderers,
                      language: "fr",
                      config: {
                        header: {
                          disableHeader: false,
                          disableFileName: true
                        }
                      }
                    }), /*#__PURE__*/_jsx(Divider, {})]
                  })
                }, 1), /*#__PURE__*/_jsxs(Tabs.TabPane, {
                  tab: /*#__PURE__*/_jsxs("b", {
                    children: [/*#__PURE__*/_jsx(Alexa, {
                      size: 30
                    }), " Avis & Transmissions"]
                  }),
                  children: [/*#__PURE__*/_jsx("br", {}), m.comments.map(function (c) {
                    return /*#__PURE__*/_jsxs("div", {
                      className: "cool-radius",
                      style: {
                        maxWidth: "440px",
                        marginBottom: "10px",
                        padding: "25px",
                        background: "#FCD013",
                        color: "#010101"
                      },
                      children: [c.content, /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("span", {
                        style: {
                          color: "grey"
                        },
                        children: c.user.prenom + " " + c.user.nom
                      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("span", {
                        style: {
                          color: "grey"
                        },
                        children: /*#__PURE__*/_jsx(Moment, {
                          format: "DD/MM/YYY",
                          children: c.created_at
                        })
                      })]
                    }, c.id);
                  })]
                }, 2)]
              })
            })
          })
        })
      })
    })
  });
};
export default MailView;